// Libs
import React from 'react'
import classNames from 'classnames'

// CSS
import "./styles.scss"

// Component/Containers
import LoadingIcon from '../LoadingIcon'

const Button = ({
  type,
  gutter,
  gutterTop,
  gutterBottom,
  align,
  localLoading,
  disabled,
  children,
  resize = true,
  link = false,
  margin,
  padding,
  fontSize,
  color,
  ...props }) => {
  const buttonStyle = {
    margin: `${gutter / 2}px 0px`,
    marginTop: `${gutterTop}px`,
    marginBottom: `${gutterBottom}px`,
    textAlign: align
  }

  const buttonClassName = classNames(
    'button',
    {
      'button--submit': !disabled && type === 'submit',
      'button--decline': !disabled && type === 'decline',
      'button--disabled': disabled,
      'button--resize': resize
    }
  )

  return (
    link ? (
      <a
        style={{ margin, padding, fontSize }}
        className={color ? `link-button link-button--${color}` : 'link-button'}
        {...props}>
        {children}
      </a>
    ) : (
      <button type={type} style={buttonStyle} className={buttonClassName} disabled={localLoading || disabled} {...props}>
        <span className="button__wrapper">
          {localLoading ? <LoadingIcon /> : children}
        </span>
      </button>
    )
  )
}

export default Button
